jQuery(function($) {

    // Accordion Content
	$('.accordion .toggle').click(function(e) {
        e.preventDefault();

        var $toggle = $(this);
        var $inner = $(this).next();
        var $container = $toggle.parent().parent();

        if( $inner.hasClass('show') ) {

            $toggle.removeClass('active');
            $inner.removeClass('show').slideUp(350);

        } else {

            $container.find('.toggle').removeClass('active');
            $container.find('li .accordion-inner').removeClass('show');
            $container.find('li .accordion-inner').slideUp(350);
            $inner.toggleClass('show');
            $inner.slideToggle(350);

        }

    });
    
});